module.exports = __webpack_public_path__ + "img/jiantoushang.c065ca78.png";